/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { ReduxUtils } from '@spm/core';
import models from './models';

/**
 * Gets ACESFIChapInfoDetails from api:
 * /v1/ua/aces_fi_chap_applied
 *
 * @param {any} callback function to call once this function has finished
 */
const fetchAcesFiChapAppliedUtil = callback => {
  ReduxUtils.getModelDataFromRestAPI(
    callback,
    `v1/ua/aces_fi_chap_applied`,
    models.ACESFIChapInfoDetails
  );
};

export { fetchAcesFiChapAppliedUtil };
